module.exports = __webpack_public_path__ + "img/tariff-selection-bg--991.2413f7e.jpg";